
import { useEffect, useRef, useState } from 'react';

export default function InstructorSection() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);

  const instructors = [
    {
      name: 'koki',
      role: '代表講師 / ギタリスト / 作詞・作編曲家 / マルチクリエイター',
      image: 'https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/62e96e0d0d00e01cca2e791be0c36d64.png',
      profile: '1997年生。ギタリスト、作詞・作編曲家。中学生からギターを始め、高校では軽音部に所属。バンドではギターと作曲を担当し、軽音楽部全国大会でオリジナル曲にて特別賞を受賞。10代限定の関西バンドコンテストではギタリスト賞も受賞。その後もバンド活動を継続し、「KANA-BOON」「ヤバイTシャツ屋さん」「崎山蒼志」など数々のメジャーアーティストと共演。現在はPCを用いて楽曲制作からアレンジ、ミュージックビデオ制作まで一人で手がけるソロクリエイターとして活動中。J-POP・ロックを中心に、長年の音楽経験を活かした実践的で分かりやすい指導を得意とする。',
      genres: ['J-POP', 'ロック', 'ボカロ', 'DTM'],
      message: '音楽は「正解」よりも「楽しむこと」が一番大切だと思っています。アイデアを考えるのは大好きなので、皆さん一人ひとりに寄り添いながら、「やってよかった」と思える時間を一緒に作っていけたら嬉しいです。皆さんとお会いできるのを楽しみにしています。よろしくお願いします！',
      experience: ''
    },
    {
      name: '福田 真由子(ふくだ まゆこ)',
      role: 'DTM講師 / ボイストレーナー',
      image: 'https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/77ae45c2272957ed172ca350b673145b.jpeg',
      profile: 'ボカロP・シンガーソングライター・作詞・作曲・編曲家。動画編集やDTPデザインにも対応するマルチクリエイター。ソロユニット「dhn」では企画から完成までを一貫して手がける。洗足学園音楽大学ミュージカルコースを卒業し、ボーカルを三橋千鶴氏に師事。小学校3年生から市民ミュージカルに出演し、藤田貴大ワークショップ公演『ハロースクール、バイバイ』にも出演。結婚式場でシンガーとして勤務していた経験もあり。制作した楽曲はテレビ朝日系列『トゲアリトゲナシトゲトゲ』で使用され、同じくテレビ朝日系列の音楽番組『musicる TV』にも出演。Deezer(日本)の"Country top charts"で1位を獲得。',
      genres: ['ボカロ', 'J-POP', 'DTM', 'ミュージカル'],
      message: 'DTMは難しそうに見えて、実はとても自由で楽しい世界です。「こんな曲を作りたい」という想いを、一緒に形にしていきましょう。初心者の方でも安心して学べるよう、基礎から丁寧にサポートします。音楽制作の楽しさを、ぜひ一緒に体験しましょう！',
      experience: ''
    },
    {
      name: 'Taku',
      role: 'ボイストレーナー / ボーカルディレクター/DTM講師',
      image: 'https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/fc878b111423c6cdf826a7298f9aa23c.png',
      profile: `音楽系専門課程にてサウンドクリエイションを専攻し、DTMを中心に作曲・アレンジ・音作り・ピッチ補正を体系的に習得。
在学中から楽曲制作と発信を行い、現在は複数の音楽スクールで幅広いレベルの生徒を指導しながら、個人アーティストとしても活動を続けている。
レッスンでは一般的なボイストレーニングにとどまらず、フースラーメソードなどの理論も踏まえた独自の視点から指導を行うことを大切にしている。
特にリズム感や言葉の乗せ方を重視したラップ指導を得意とし、表現力を引き出すレッスンを行っている。`,
      genres: ['J-POP', 'R&B', 'ロック', '洋楽', 'ラップ'],
      message: `声そのものに良い・悪いはないと考えています。
歌うことに苦手意識が生まれるのは自分の声の活かし方をまだ知らないだけ。
あなたの声が持っている個性や魅力を見つけ最大限に引き出せるよう、全力でサポートします。`,
      experience: ''
    },
    {
      name: '久保田 貴大（くぼた　たかひろ）',
      role: 'ベーシスト / インストラクター',
      image: 'https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/bfdc1e21db6a0956c62a5ff7f92d15f3.png',
      profile: 'ベーシストとして15年の音楽活動歴を持ち、ギタリストのJoe-Gと共にテクニカルインスト楽曲のリリースや、ボカロPのYKTTZとの楽曲制作・アーティストサポートなど、幅広いフィールドで活動。ロックからJ-POP、R&B、FUNK、アニソンまで多彩なジャンルに対応し、演奏・制作の両面から音楽に携わってきた。また、13年にわたるレッスン経験を持ち、初心者から経験者まで、一人ひとりのレベルや目標に合わせた丁寧で分かりやすい指導に定評がある。',
      genres: ['ロック', 'J-POP', 'R&B', 'FUNK', 'アニソン'],
      message: '落ち着いた雰囲気で、丁寧に寄り添いながら進めるレッスンを心がけています。一人ひとりのペースを大切にし、課題点を一緒に見つけて改善しながら、楽しく確実にステップアップしていきましょう。「楽しく、でも真剣に」を大切に、目標達成に向けて全力でサポートします。',
      experience: ''
    }
  ];

  return (
    <section id="instructor" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 
            ref={headingRef}
            className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            歌い手の"はじめて"に寄り添う講師陣
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            あなたの成長を、最後まで見守ります
          </p>
        </div>

        <div className="space-y-8 sm:space-y-10 md:space-y-12">
          {instructors.map((instructor, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 md:p-10 lg:p-12 rounded-2xl sm:rounded-3xl shadow-xl border-2 border-gray-100"
            >
              <div className="flex flex-col md:flex-row gap-6 sm:gap-8 md:gap-10 items-center">
                <div className="flex-shrink-0">
                  <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl">
                    <img
                      src={instructor.image}
                      alt={`${instructor.name}講師`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className="flex-1">
                  <div className="mb-4 sm:mb-6">
                    <h3 className="text-2xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                      {instructor.name}
                    </h3>
                    <p className="text-base sm:text-lg text-orange-500 font-bold">
                      {instructor.role}
                    </p>
                  </div>

                  <div className="space-y-4 sm:space-y-6">
                    <div>
                      <h4 className="text-base sm:text-lg font-bold text-gray-700 mb-2 sm:mb-3 flex items-center gap-2">
                        <i className="ri-user-star-line text-lg sm:text-xl text-orange-500"></i>
                        プロフィール
                      </h4>
                      <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                        {instructor.profile}
                      </p>
                    </div>

                    <div>
                      <h4 className="text-base sm:text-lg font-bold text-gray-700 mb-2 sm:mb-3 flex items-center gap-2">
                        <i className="ri-music-line text-lg sm:text-xl text-orange-500"></i>
                        得意ジャンル
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        {instructor.genres.map((genre, genreIndex) => (
                          <span
                            key={genreIndex}
                            className="bg-orange-50 text-orange-600 text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full"
                          >
                            {genre}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h4 className="text-base sm:text-lg font-bold text-gray-700 mb-2 sm:mb-3 flex items-center gap-2">
                        <i className="ri-chat-quote-line text-lg sm:text-xl text-orange-500"></i>
                        メッセージ
                      </h4>
                      <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 border-orange-100">
                        <p className="text-sm sm:text-base text-gray-700 leading-relaxed whitespace-pre-wrap">
                          {instructor.message}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
